import AxiosInstance from "./api";

export const RegisterOwnSharesPurchasedService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/register-own-shares-purchased", {
      params: query,
    });
  },

  getInit: async () => {
    return await AxiosInstance.get("/private/register-own-shares-purchased/init");
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/register-own-shares-purchased/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/register-own-shares-purchased", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/register-own-shares-purchased/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/register-own-shares-purchased/" + id);
  },
};
